(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("jQuery"));
	else if(typeof define === 'function' && define.amd)
		define(["jQuery"], factory);
	else if(typeof exports === 'object')
		exports["Mso"] = factory(require("jQuery"));
	else
		root["Mso"] = factory(root["jQuery"]);
})(self, (__WEBPACK_EXTERNAL_MODULE_jquery__) => {
return 